import React from 'react';
import type { DateRangeFilter, CustomDateRange } from '../../../types/dashboard.types';
import styles from './FilterPanel.module.css';

export interface FilterPanelProps {
  value: DateRangeFilter;
  customRange?: CustomDateRange | null;
  onFilterChange: (filter: DateRangeFilter, custom?: CustomDateRange | null) => void;
  loading?: boolean;
}

const FILTER_OPTIONS: { id: DateRangeFilter; label: string }[] = [
  { id: 'today', label: 'Today' },
  { id: 'last7days', label: 'Last 7 days' },
  { id: 'last30days', label: 'Last 30 days' },
  { id: 'alltime', label: 'All-time' },
];

const FilterPanel: React.FC<FilterPanelProps> = ({ value, onFilterChange, loading = false }) => (
  <div className={styles.inlinePanel} role="group" aria-label="Date range filter">
    <div className={styles.buttons}>
      {FILTER_OPTIONS.map((opt) => (
        <button
          key={opt.id}
          type="button"
          className={`${styles.btn} ${value === opt.id ? styles.active : ''}`}
          onClick={() => onFilterChange(opt.id)}
          disabled={loading}
        >
          {opt.label}
        </button>
      ))}
    </div>
  </div>
);

export default FilterPanel;
